import { useDataContext } from 'context/data-context'
import tj from 'locale/tj'
import ru from 'locale/ru'

const locales = {
  tj,
  ru,
}

export type Locale = typeof locales['tj' | 'ru']

export const useLocale = () => {
  const { appLocale } = useDataContext()

  return {
    ...locales[appLocale],
    lang: appLocale,
    localize: (texttj?: string, textRu?: string) =>
      appLocale === 'tj' ? texttj : textRu,
  }
}
